module.exports = __webpack_public_path__ + "static/img/20.de791a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home-en/20.png
// module id = xITy
// module chunks = 0